import React, { FC } from 'react';

import cn from 'classnames';

import { Nullable } from '../../../../types/general';

import Icon from '../../../ui/icon/icon';

import SvgSubtract from './images/Subtract.svg';

import css from './panel.css';

interface Props {
    leftPanel?: Nullable<React.ReactElement>;
    className?: string;
    mainPanelClassName?: string;
}

const Panel: FC<React.PropsWithChildren<Props>> = ({
    children,
    leftPanel,
    className,
    mainPanelClassName,
}) => (
    <div className={cn(css.root, className)}>
        {leftPanel && (
            <div className={css.leftPanel}>
                <div className={css.leftPanelBackground}>
                    <Icon glyph={SvgSubtract} />
                </div>
                {leftPanel}
            </div>
        )}
        <div className={cn(css.mainPanel, mainPanelClassName)}>{children}</div>
    </div>
);

export default Panel;
